import React from 'react';
import PropTypes from 'prop-types';
import InlineSVG from 'svg-inline-react';
import classes from './SplitButton.scss';

export class SplitButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: typeof props.selected !== 'undefined' ? props.selected : null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.selected !== 'undefined') {
      this.setState({
        selected: nextProps.selected,
      });
    }
  }

  handleClick = value => {
    this.props.onSelect(value);
  };

  render() {
    const buttons = this.props.buttons.map(button => {
      let className = '';

      if (button.value === this.state.selected) {
        className = classes.selected;
      }

      let image = null;
      if (typeof button.img !== 'undefined' && button.img !== null) {
        image = <InlineSVG src={button.img} />;
      }

      return (
        <a
          onClick={() => this.handleClick(button.value)}
          className={className}
          key={`splitbutton_${button.value}`}
        >
          {image}
          {button.title}
        </a>
      );
    });

    let cssClass = classes.splitButtonContainer;

    if (this.props.fullWidth) {
      cssClass = `${cssClass} ${classes.fullWidth}`;
    }

    return (
      <div className={`${cssClass} ${this.props.className}`}>{buttons}</div>
    );
  }
}

SplitButton.propTypes = {
  selected: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]),
  buttons: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

SplitButton.defaultProps = {
  fullWidth: false,
  className: '',
};

export default SplitButton;



// WEBPACK FOOTER //
// ./src/components/SplitButton/SplitButton.js